import React, { useState, useEffect } from 'react';
import { IonContent, IonPage, IonButton, IonText } from '@ionic/react';

// Helper function to generate random letters
const generateRandomLetter = (length: number): string[] => {
    const letters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ';
    const randomLetters: string[] = [];
    for (let i = 0; i < length; i++) {
        const randomChar = letters.charAt(Math.floor(Math.random() * letters.length));
        randomLetters.push(randomChar);
    }
    return randomLetters;
};

// List of available dynamic patterns (Shapes, Colors, Letters)
const patterns = {
    shapes: ['⭐', '🌀', '◼', '🟡', '🔶', '🔺'], // Random set of shapes
    colors: ['🟢', '🟡', '🔴', '🔵', '🟣', '🟤'], // Random set of colors
    letters: generateRandomLetter(10), // Random set of 10 letters
} as const;

// Extract the keys of the patterns object as a type
type PatternType = keyof typeof patterns;

const PatternComponent: React.FC = () => {
    const [selectedPattern, setSelectedPattern] = useState<PatternType>('shapes');
    const [choosedPattern, setChoosedPattern] = useState<string>('');
    const [patternSequence, setPatternSequence] = useState<string>(''); // Change to string
    const [userChoice, setUserChoice] = useState<string>('');
    const [correctChoice, setCorrectChoice] = useState<string>('');
    const [isCorrect, setIsCorrect] = useState<boolean | null>(null);
    const [options, setOptions] = useState<string[]>([]);
    const [showImage, setShowImage] = useState(false);
    const [error, setError] = useState(false);
    const [selectedOption, setSelectedOption] = useState<number | null>(null);

    // Randomly select a pattern and generate the question
    const generateRandomPatternQuestion = () => {
        const patternKeys: PatternType[] = ['shapes', 'colors', 'letters'];
        const randomPattern = patternKeys[Math.floor(Math.random() * 3)]; 
        const pattern = shuffleArray(patterns[randomPattern]);
        
        let sequence = "";
        let nextItem = "";

        const repetitionType = Math.floor(Math.random() * 5); // 0 to 7 for 8 patterns

        switch (repetitionType) {
            case 0: 
                sequence = `${pattern[0]} ${pattern[1]} ${pattern[0]} ${pattern[1]} ${pattern[0]} ${pattern[1]} ${pattern[0]}`;
                nextItem = pattern[1];
                break;
            case 1: 
                sequence = `${pattern[0]} ${pattern[1]} ${pattern[2]} ${pattern[3]} ${pattern[0]} ${pattern[1]} ${pattern[2]}`;
                nextItem = pattern[3];
                break;
            case 2: 
                sequence = `${pattern[0]} ${pattern[0]} ${pattern[1]} ${pattern[1]} ${pattern[2]} ${pattern[2]} ${pattern[0]}`;
                nextItem = pattern[0];
                break;
            case 3: 
                sequence = `${pattern[0]} ${pattern[1]} ${pattern[2]} ${pattern[0]} ${pattern[1]} ${pattern[2]} ${pattern[0]}`;
                nextItem = pattern[1];
                break;
            case 4: 
                sequence = `${pattern[0]} ${pattern[1]} ${pattern[1]} ${pattern[1]} ${pattern[0]} ${pattern[1]} ${pattern[1]}`;
                nextItem = pattern[1];
                break;
            default:
                sequence = `${pattern[0]} ${pattern[1]}`;
                nextItem = pattern[0];
        }

        // Generate the incorrect options
        const incorrectOptions = generateIncorrectOptions(randomPattern, nextItem);

        // Set the sequence, correct answer, and options
        setChoosedPattern(randomPattern)
        setSelectedPattern(randomPattern);
        setPatternSequence(sequence); // Keep as a string
        setCorrectChoice(nextItem);
        setUserChoice('');
        setIsCorrect(null);
        setOptions(shuffleArray([nextItem, ...incorrectOptions]));
    };
    

    const shuffleArray = (array: any) => {
        return [...array].sort(() => Math.random() - 0.5);
    };

    // Generate 2 incorrect options
    const generateIncorrectOptions = (patternType: PatternType,correctAnswer: string): string[] => {
        
        const allOptions = [...patterns[patternType]]; 
        const filteredOptions = allOptions.filter((option) => option !== correctAnswer);
        const randomOptions: string[] = [];

        while (randomOptions.length < 2) {
            const randomIndex = Math.floor(Math.random() * filteredOptions.length);
            const option = filteredOptions[randomIndex];
            if (!randomOptions.includes(option)) {
                randomOptions.push(option);
            }
        }
        return randomOptions;
    };

    // Function to handle user selection and check correctness
    const handleAnswerSubmit = (selected: string) => {
        setUserChoice(selected);
        setIsCorrect(selected === correctChoice);


        if (selected === correctChoice) {
            setShowImage(true);
            setTimeout(() => {
                generateRandomPatternQuestion();
                setShowImage(false);
                setError(false);
            }, 5000); // Generate a new question after a correct answer
        }
        else {
            setError(true);
        }
    };

    // Generate a random pattern question when the component mounts
    useEffect(() => {
        generateRandomPatternQuestion();
        document.title = "Mamas Guidance - Class Two - Mathematics - Patterns - Repeating Pattern"; // Set page title
    }, []);

    return (
    <>
        {
            showImage === false ?
            <>
                <div className='contentPart showCenter additionWord'>
                    <div className="ion-padding">
                        {/* Displaying the Current Sequence */}
                        <div style={{ fontSize: '2em', marginTop: '20px' }}>
                            {patternSequence}
                        </div>

                        {/* Buttons for user's choices */}
                        <div style={{ marginTop: '20px' }}>
                            <IonText>What comes next in the pattern?</IonText>
                            <div className='optionDiv' style={{ marginTop: '20px' }}>
                                {options.map((option, index) => (
                                <div
                                    key={index}
                                    onClick={() => handleAnswerSubmit(option)}
                                        style={{ margin: '5px' }}
                                        className={`optionButton ${
                                            userChoice === option
                                            ? option === correctChoice
                                                ? 'correct'
                                                : 'incorrect'
                                            : ''
                                        }`}
                                >
                                    {option}
                                </div>
                                ))}
                            </div>
                        </div>
                    </div>
                </div>
                </>
                :
                <>
                    <div className="contentPart showMiddle">
                        <img style={{height: '150px'}} className='img-fluid' src={process.env.REACT_APP_WELDONE_LINK} />
                    </div>
                </>
            }
        </>
    );
};

export default PatternComponent;
